import { FlexColumn } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'

export const SketchBanner = () => {
  return (
    <div className={'relative'}>
      <FlexColumn className={'align-center mx-auto max-w-[1080px] gap-4 py-12'}>
        <Image
          src={'/v1754667374/sketch/Giveaway-Banner-1080x420.webp'}
          alt={'Win This Red Komodo X Package'}
          width={1080}
          height={420}
          className={'hidden md:block'}
        />
        <Image
          src={'/v1754667374/sketch/Giveaway-Banner_380x304.webp'}
          alt={'Win This Red Komodo X Package'}
          className={'mx-auto md:hidden'}
          width={380}
          height={304}
        />
      </FlexColumn>
    </div>
  )
}
